import { subscriptionDetails as EnUsSubscriptionDetails } from '../en-us/subscriptionDetails';
import { AgResourceLanguage } from '../types';

export const subscriptionDetails: AgResourceLanguage['subscriptionDetails'] = {
  ...EnUsSubscriptionDetails,
  orderFields: {
    ...EnUsSubscriptionDetails.orderFields,
    subscriptionTextBtn: 'Product Toevoegen aan Abonnement',
    subscriptionSubtotal: 'Subtotaal Abonnement',
    nextSubtotal: 'Subtotaal Eenmalige Toevoegingen',
    nextTextBtn: 'Product Toevoegen aan Volgende Bestelling',
    subscriptionTitle: 'Abonnementsproducten',
    nextTitle: 'Eenmalige Toevoegingen'
  },
  active: {
    ...EnUsSubscriptionDetails.active,
    exploreButton: 'Product toevoegen',
    free: 'Gratis',
    shippingAddress: 'Verzendadres',
    subscriptionButton: 'Producten Toevoegen',
    orderTotal: 'Besteltotaal:',
    nextOrderButton: 'Product Toevoegen aan Volgende Bestelling',
    emtyTitle: 'Eenmalige Toevoegingen:',
    qty: 'x',
    subscriptionProductsTitle: 'Abonnementsproducten',
    lastOrderDetails: 'Details Laatste Bestelling',
    backButton: 'Terug naar Lijst',
    emptyText:
      'Shop het volledige assortiment AG1-producten en accessoires, exclusief beschikbaar voor leden.',
    emptyButton: 'Product Toevoegen aan Volgende Bestelling',
    nextOrderLabel: 'Volgende Besteldatum:',
    addOns: 'Eenmalige Toevoegingen:',
    nextShipmentTitle: 'Volgende Bestelling'
  },
  reactivate: {
    ...EnUsSubscriptionDetails.reactivate,
    headline: 'Je abonnement is geannuleerd en een bevestiging is verzonden naar {{email}}.',
    title: 'Voor het geval je ons mist...',
    subTitle:
      'We zouden het geweldig vinden als je terugkomt! Wist je dat deze opties het gemakkelijk maken om een levering over te slaan of meer waarde uit je AG1- abonnement te halen?',
    agzSubTitle:
      'We zouden het geweldig vinden als je terugkomt! Je kunt op elk moment inloggen en je abonnement herstarten door op "reactiveren" te klikken.',
    reactivateOfferCard: {
      ...EnUsSubscriptionDetails.reactivate.reactivateOfferCard,
      delay: {
        heading: '“Ik heb te veel.”',
        text: 'Heb je wat tijd nodig om bij te komen? Stel je volgende levering van AG1 uit.',
        btnText: 'Heractiveer & Uitstellen'
      },
      skip: {
        heading: '“Ik heb te veel.”',
        text: 'Heb je wat tijd nodig om bij te komen? Sla je volgende levering van AG1 over.',
        btnText: 'Heractiveer & Overslaan'
      },
      switch: {
        heading: '“Ik heb een beperkt budget.”',
        textTwoPouches:
          'Schakel over naar 2 zakken die elke 60 dagen worden verzonden om te profiteren van ledenprijzen met minder leveringen (een waarde van {{symbolCurrency}}18).',
        textThreePouches:
          'Schakel over naar 3 zakken die elke 90 dagen worden verzonden om te profiteren van ledenprijzen en gratis verzending – een waarde van {{symbolCurrency}}42.',
        btnText: 'Heractiveer & Overschakelen'
      },
      upgrade: {
        heading: '“Ik hou niet van de smaak.”',
        text: 'Schakel met één klik uw abonnement over naar onze geüpgradede formule met meer probiotica, voedingsstoffen en een nieuwe tropische smaak.',
        learnMoreLinkText: 'Meer informatie.',
        btnText: 'Opnieuw activeren en upgraden'
      }
    }
  },
  reactivateConfirm: {
    ...EnUsSubscriptionDetails.reactivateConfirm,
    title: 'Bevestig je nieuwe plan',
    tableHead: 'Je wordt gefactureerd op:',
    tableSubHead: 'Je hebt een',
    tableSubHeadValue: 'waarde',
    tableSubHeadOn: 'ontgrendeld op',
    subTotal: 'Subtotaal',
    shipping: 'Verzending',
    free: 'GRATIS',
    total: 'Totaal',
    confirmButton: 'Bevestigen',
    cancelButton: 'Geen dank',
    offer: {
      subtitleThreePouches:
        'Heractiveer je abonnement en profiteer van exclusieve ledenprijzen en gratis verzending – een waarde van {{symbolCurrency}}42.',
      subtitleTwoPouches:
        'Heractiveer je abonnement en profiteer van exclusieve ledenprijzen met minder leveringen – een waarde van {{symbolCurrency}}18.',
      promotionText: '{{pouches}} zakken en minder leveringen'
    },
    newPlan: {
      title: 'Je nieuwe AG1-plan:',
      titleSecondary: 'Je AG1 wordt verzonden:',
      mainText: '{{pouches}} zakken verzonden elke {{days}} dagen',
      nextShipment: 'Volgende levering:'
    }
  },
  reactivateSuccess: {
    ...EnUsSubscriptionDetails.reactivateSuccess,
    title: 'We zijn blij je terug te hebben!',
    subBtn: 'Bekijk mijn abonnement',
    learnMore: {
      title: 'Fundamentele voeding in één enkele schep',
      text: 'Elke schep AG1 bevat de gezondheidsvoordelen voor het hele lichaam die je nodig hebt in een eenvoudige dagelijkse gewoonte.*',
      btnText: 'Meer informatie'
    },
    offer: {
      skip: 'We hebben je lidmaatschap opnieuw geactiveerd en je volgende levering overgeslagen. Samen zorgen we voor onze gezondheid.',
      delay:
        'We hebben je lidmaatschap opnieuw geactiveerd en je volgende levering uitgesteld. Samen zorgen we voor onze gezondheid.',
      default:
        'We hebben je lidmaatschap opnieuw geactiveerd. Samen zorgen we voor onze gezondheid.'
    }
  },
  v2: {
    ...EnUsSubscriptionDetails.v2,
    active: {
      ...EnUsSubscriptionDetails.v2.active,
      nextOrderTitle: 'Volgende bestelling',
      shippingFrequency: 'Verzendfrequentie',
      item: 'Elke'
    },
    editFrequency: {
      day: 'Dag'
    },
    orderItems: {
      subscriptionDescription: 'Abonnement',
      nextOrderOnlyDescription: 'Alleen voor deze bestelling',
      toBeAppliedAfterNextOrder: 'Wordt toegepast na de volgende bestelling'
    },
    reactivate: {
      success: 'Je abonnement is opnieuw geactiveerd'
    },
    errors: {
      apiError: 'Vi upplever ett tillfälligt tekniskt problem. Försök igen senare, tack.'
    }
  }
};
